/*
 * @Author: Zhouqi
 * @Date: 2025-10-29 16:58:07
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-08 13:36:18
 */
import request from '@/utils/request';

import { ApiResult } from '..';

interface machineType {
  url: string;
  imageMd5: string;
  // reviewScenes?: string[];
}

/**
 * 图片审核
 * @param data
 * @returns
 */
export const imageVerify = async (data: machineType): Promise<ApiResult<any>> => {
  // const params = {
  //   ...data,
  //   // 13-暴恐&违禁识别, 16-图片文本审核
  //   reviewScenes: ['13', '16'],
  // };
  const res = await request('/api/rest/dlt/review/machine/sync', {
    method: 'POST',
    data,
  });
  return res;
};
